var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adminContent"},[_c('img',{staticClass:"backgroundImg",attrs:{"src":require("../assets/global.jpg"),"alt":"background"}}),_c('v-container',[_c('Login',{staticClass:"login"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }